var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlinkLiability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49997 4.75H8.74997V6.25H9.49997H9.69369L11.2966 8.79778L11.2966 8.79776L9.69371 6.25H17.7227C17.549 8.59142 16.5739 10.0859 15.6253 11.0144C15.4341 11.2016 15.2429 11.3667 15.0581 11.5116L16.1525 12.5561C16.3244 12.414 16.4995 12.2577 16.6746 12.0863C17.9785 10.81 19.25 8.72213 19.25 5.5C19.25 5.08579 18.9142 4.75 18.5 4.75H9.49997ZM19.2499 19.4455L17.6169 17.8869C17.6648 18.1556 17.701 18.4428 17.7234 18.75H6.27628C6.4484 16.3573 7.44375 14.8927 8.60715 13.9981C9.74936 13.1198 11.1082 12.751 12.1496 12.669L10.7871 11.3687C9.77858 11.6039 8.6788 12.0508 7.6928 12.809C6.02317 14.0928 4.75 16.2175 4.75 19.5C4.75 19.6989 4.82902 19.8897 4.96967 20.0303C5.11032 20.171 5.30109 20.25 5.5 20.25H18.5C18.9142 20.25 19.25 19.9142 19.25 19.5C19.25 19.4818 19.25 19.4636 19.2499 19.4455ZM9.69371 6.25L8.74997 4.75L9.69369 6.25H9.69371Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4813 22.0006L3.78727 6.59085L4.71853 5.40093L21.4126 20.8107L20.4813 22.0006Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlinkLiability);
export default __webpack_public_path__ + "static/media/Unlink-liability.97a7a68af832d6a2036ffdc2dee92ae8.svg";
export { ForwardRef as ReactComponent };